var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-kng-operator__multi" },
    [
      _vm.module === "ulcd"
        ? _c("yxt-alert", {
            staticClass: "mb24",
            attrs: {
              title: _vm.$t(
                "pc_biz_lbl_couseuploadtip" /**课程发布成功后，上传的文件会自动生成课件，可以在课件管理中查看，默认隐藏，学员不可见 */
              ),
              type: "regular",
              "show-icon": "",
              closable: false,
            },
          })
        : _vm._e(),
      _c(
        "yxt-button",
        {
          attrs: { disabled: _vm.infoList.length >= _vm.maxLength },
          on: { click: _vm.continueUpload },
        },
        [_vm._v(_vm._s(_vm.$t("pc_comp_upload_continue" /** 继续上传 */)))]
      ),
      _vm.infoList.length > 1
        ? _c("yxt-button", { on: { click: _vm.multiEdit } }, [
            _vm._v(
              _vm._s(_vm.$t("pc_kng_upload_lbl_batch_change" /**批量修改 */))
            ),
          ])
        : _vm._e(),
      _vm.infoList.length
        ? _c(
            "div",
            {
              staticClass:
                "yxtbiz-flex-center yxtbiz-kng-operator__multi-th pv14 ph24 mt16",
            },
            [
              _c("yxt-checkbox", {
                attrs: {
                  value: _vm.checkAll,
                  indeterminate: _vm.isIndeterminate,
                },
                on: {
                  change: function ($event) {
                    return _vm.handleCheckAll(_vm.checkAll)
                  },
                },
              }),
              _c("div", { staticClass: "yxtbiz-flex-1 ml12 over-hidden" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_biz_kng_lbl_courseware_name" /** 课件名称*/)
                  )
                ),
              ]),
              _c("div", { staticClass: "yxtbiz-w240 ml12" }, [
                _vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_status" /**状态 */))),
              ]),
              _c("div", { staticClass: "yxtbiz-w110 ml12" }, [
                _vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_operate" /**操作 */))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.infoList, function (item) {
        return _c("div", { key: item._uuid }, [
          _c(
            "div",
            {
              staticClass:
                "yxtbiz-flex-center yxtbiz-kng-operator__multi-tr pv14 ph24",
            },
            [
              _c("yxt-checkbox", {
                attrs: {
                  value: _vm.isSelected(item),
                  disabled: item._status === 1,
                },
                on: {
                  change: function ($event) {
                    return _vm.change(item)
                  },
                },
              }),
              _c("div", { staticClass: "yxtbiz-flex-1 ml12 over-hidden" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "yxtbiz-flex-center yxtbiz-kng-operator__kngName",
                    on: {
                      click: function ($event) {
                        return _vm.clickRow(item, $event)
                      },
                    },
                  },
                  [
                    _c("yxt-svg", {
                      attrs: {
                        "remote-url": _vm.kngFileTypeIconUrl,
                        width: "20px",
                        height: "20px",
                        "icon-class": _vm.getTypeIcon(item),
                      },
                    }),
                    _vm.current === item
                      ? _c("yxt-input", {
                          staticClass: "yxtbiz-kng-operator__table-input",
                          attrs: {
                            maxlength: "200",
                            autofocus: "",
                            "show-word-limit": "",
                          },
                          on: {
                            blur: function ($event) {
                              _vm.current = undefined
                            },
                          },
                          model: {
                            value: item.title,
                            callback: function ($$v) {
                              _vm.$set(item, "title", $$v)
                            },
                            expression: "item.title",
                          },
                        })
                      : _c(
                          "span",
                          {
                            staticClass:
                              "yxtbiz-kng-operator__table-title ellipsis-1 yxtbiz-flex-1",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                "\n            "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "yxtbiz-w240 ml12" },
                [
                  item._status === 0
                    ? _c("yxt-progress", {
                        staticClass: "yxtbiz-w100",
                        attrs: { percentage: item._percentage },
                      })
                    : item._status === 1
                    ? _c(
                        "yxt-tag",
                        { attrs: { "is-status-tag": "", type: "danger" } },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: { content: item._error, placement: "top" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-w200 over-hidden ellipsis",
                                },
                                [_vm._v(_vm._s(item._error))]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "yxt-tag",
                        { attrs: { "is-status-tag": "", type: "success" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_upload_lbl_already_success_other" /**上传成功 */
                              )
                            )
                          ),
                        ]
                      ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "yxtbiz-w110 ml12" },
                [
                  item._status !== 1
                    ? [
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.expand(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item._expand
                                  ? _vm.$t(
                                      "pc_kng_common_btn_pack_up" /**收起 */
                                    )
                                  : _vm.$t(
                                      "pc_kng_common_btn_pack_open" /**展开 */
                                    )
                              )
                            ),
                          ]
                        ),
                        _c("yxt-divider", { attrs: { direction: "vertical" } }),
                      ]
                    : _vm._e(),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.del(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_delete" /**删除 */)))]
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item._expand,
                  expression: "item._expand",
                },
              ],
              key: "2_" + item._uuid,
              staticClass: "pv24 ph8 yxtbiz-kng-operator__multi-tr",
            },
            [
              _c("kng-form", {
                ref: "forms_" + item._uuid,
                refInFor: true,
                staticClass: "yxtbiz-w640",
                attrs: { info: item },
              }),
            ],
            1
          ),
        ])
      }),
      _c("kng-edit-multi-drawer", {
        ref: "editMulti",
        on: { confirm: _vm.confirm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }